import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { fetchOperatorGroup, fetchSiteSettings } from '../core/actions';
import {
  selectAnalyticsEnabled,
  selectRole,
  selectUserGroupDynamicPermissions,
} from '../store/authReducer';
import { fetchReport, fetchVisualReport } from '../views/analytics/actions';
import { selectEmbedToken } from '../views/analytics/reducer';
import { setSelectedSite } from '../views/site-selection/actions';
import { SAFETY_INTERVAL } from '../views/analytics/sagas';
import { useAppContext } from '../providers/AppProvider';
interface Props {
  children: React.ReactNode;
}

const SiteDispatcher = ({ children }: Props) => {
  const { site } = useParams<{ site: string }>();
  const dispatch = useDispatch();

  const analyticsEnabled = useSelector(selectAnalyticsEnabled);
  const isAdmin = useSelector(selectRole);
  const analyticsDynamicPermissions = useSelector(selectUserGroupDynamicPermissions);
  const history = useHistory();
  const { isWashClub } = useAppContext();
  const reportType = isWashClub ? 'Manager-Analytics-WashClub' : 'Manager-Analytics';
  const token = useSelector((state) => selectEmbedToken(state, reportType));

  useEffect(() => {
    if (site) {
      dispatch(setSelectedSite({ id: site }));
    }
    if (!token) {
      dispatch(fetchSiteSettings(history, '/site-selection'));

      if (
        isAdmin ||
        analyticsEnabled ||
        (Array.isArray(analyticsDynamicPermissions) &&
          analyticsDynamicPermissions.some((permission) =>
            permission.ref.includes('analytics_tabs')
          ))
      ) {
        dispatch(fetchReport(SAFETY_INTERVAL, reportType, isWashClub));
        //Currently used for testing dashboard tiles
        //dispatch(fetchVisualReport(SAFETY_INTERVAL, 'Tile-Testing', true));
      }
    }
    dispatch(fetchOperatorGroup());
  }, []);

  return children;
};

export default SiteDispatcher;
